import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    formState: "signIn",
    loginState: false,
    loginUserId: "",
    loginUserInfo: "",
    
    accessToken: "",
    idToken: "",
    currentDiagnosisId: "",
    beforePath: "",
    languages : ["日本語","English","中文"],
    language: "日本語",
    sleepTest: {},
    sleepTestIndex: 0
  },

  getters: {
    getFormState: state => state.formState,
    getLoginState: state => state.loginState,
    getLoginUserId: state => state.loginUserId,
    getLoginUserInfo: state => state.loginUserInfo,
    getAccessToken: state => state.accessToken,
    getIdToken: state => state.idToken,
    getCurrentDiagnosisId: state => state.currentDiagnosisId,
    getBeforePath: state => state.beforePath,
    getLanguages: state => state.languages,
    getLanguage: state => state.language,
    getSleepTest: state => state.sleepTest,
    getSleepTestIndex: state => state.sleepTestIndex
  },

  mutations: {
    setValueToFormState(state, newState) {
      state.formState = newState;
    },
    setValueToLoginState(state, newState) {
      state.loginState = newState;
    },
    setValueToLoginUserId(state, newState) {
      state.loginUserId = newState;
    },
    setValueToLoginUserInfo(state, newState) {
      state.loginUserInfo = newState;
    },    
    setValueToAccessToken(state, newState) {
      state.accessToken = newState;
    },
    setValueToIdToken(state, newState) {
      state.idToken = newState;
    },    
    setValueToCurrentDiagnosisId(state, newState) {
      state.currentDiagnosisId = newState;
    },
    setValueToBeforePath(state, newState) {
      state.beforePath = newState;
    },
    setValueToLanguages(state, newState) {
      state.languages = newState;
    },
    setValueToLanguage(state, newState) {
      state.language = newState;
    },
    setValueToSleepTest(state, newState) {
      state.sleepTest = newState;
    },
    setValueToSleepTestIndex(state, newState) {
      state.sleepTestIndex = newState;
    },
  }
});
